var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"shadow"},[_c('highcharts',{staticStyle:{"margin-top":"50px"},attrs:{"options":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }